module.exports = __webpack_public_path__ + "80cf75551ac1c7234d06119266391c18.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1/public/history/fi-2006.png
// module id = 383
// module chunks = 0